module.exports = __webpack_public_path__ + "static/media/14UNEP21.23211a9f.jpg";